import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import useNotification from "../../components/shared/Notifications/useNotifications";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISerpQuerySettings } from "../../models/SerpQuery/SerpQuery";
import { SerpQueryKeys } from "./keys";

export default function useSerpQuerySettingsMutations() {
  const { put } = useApiHelper();
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Serp settings");
  const { addNotification } = useNotification();

  const save = useMutation({
    mutationFn: (settings: ISerpQuerySettings) =>
      put<IDefaultResponse<ISerpQuerySettings>, ISerpQuerySettings>(
        "/serp-query-settings",
        settings,
      ),
    onSuccess: () => {
      saveHandlers.onSuccess();
      queryClient.invalidateQueries({ queryKey: SerpQueryKeys.all() });
    },
    onError: (error: Error) => {
      addNotification({
        variant: "error",
        primaryText: error.message || "Failed to save Serp settings",
      });
    },
  });

  return { save };
}
